import { createContext, useCallback, useContext, useState } from "react";
import type { ReactNode } from "react";
import { createPortal } from "react-dom";

type Toast = { id: number; text: string };
type ToastCtx = { show: (text: string) => void };

const Ctx = createContext<ToastCtx | null>(null);
let nextId = 1;

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<Toast[]>([]);
  const show = useCallback((text: string) => {
    const id = nextId++;
    setItems((s) => [...s, { id, text }]);
    setTimeout(() => setItems((s) => s.filter((t) => t.id !== id)), 2500);
  }, []);

  return (
    <Ctx.Provider value={{ show }}>
      {children}
      {typeof document !== "undefined" && createPortal(
        <>{items.map((t) => <div key={t.id} className="toast">{t.text}</div>)}</>,
        document.body,
      )}
    </Ctx.Provider>
  );
}

export function useToast(): ToastCtx {
  const c = useContext(Ctx);
  if (!c) return { show: () => {} }; // safe no-op outside provider
  return c;
}
